export default {
  caseStudies: {
    page: {
      tagline: 'Historias de éxito de clientes',
      headline: 'Resultados reales de',
      headlineHighlight: 'equipos de entrega reales',
      description:
        'Descubre cómo equipos de entrega y logística — restaurantes, farmacias, supermercados, mensajería y paquetería, e-commerce y 3PL — usan Geofleet para optimizar la última milla, reducir costes y deleitar a los clientes.',
    },
    featured: { label: 'Historia de éxito destacada' },
    filters: {
      label: 'Filtrar por sector',
      allIndustries: 'Todos los sectores',
      ariaLabel: 'Filtrar casos de estudio por sector',
    },
    list: {
      title: 'Historias de clientes',
      defaultSubtitle: 'Desafíos reales, soluciones concretas, resultados medibles en equipos de entrega',
      countInIndustry_one: '{{count}} historia en este sector',
      countInIndustry_other: '{{count}} historias en este sector',
      story_one: '{{count}} historia',
      story_other: '{{count}} historias',
    },
    empty: {
      title: 'No hay historias en este sector',
      hint: 'Prueba a seleccionar otro filtro de sector.',
    },
    card: { readFullStory: 'Leer la historia completa' },
    explore: { badge: 'Cómo explorar' },
    cta: {
      title: '¿Listo para escribir tu historia de éxito?',
      subtitle: 'Únete a los equipos de entrega que logran resultados similares con Geofleet.',
    },
    detail: {
      schemaSection: 'Caso de estudio',
      backLink: 'Todos los casos de estudio',
      challengeHeading: 'El desafío',
      solutionHeading: 'La solución',
      analytics: { metric: 'Métrica', before: 'Antes', after: 'Después' },
      timelineTitle: 'Cronograma de implementación',
      keyTakeaways: 'Puntos clave',
      relatedTitle: 'Casos de estudio relacionados',
      exploreSolution: {
        badge: 'Explorar la solución',
        title: 'Descubre cómo funciona Geofleet para {{industry}}',
      },
      cta: {
        title: 'Obtén resultados similares',
        subtitle: 'Descubre cómo Geofleet puede ayudar a tu equipo. Empieza ya o reserva una demo personalizada.',
      },
    },
  },
};
